import React from 'react';
import { CodeWithSyntaxHighlight } from './CodeWithSyntaxHighlight';
import { Label } from './Label';
import { jsx as ___EmotionJSX } from "@emotion/react";
const UserInputDisplayer = _ref => {
  let {
    colorizeCodeElement,
    theme,
    userInput
  } = _ref;
  return ___EmotionJSX("div", {
    style: {
      alignItems: 'baseline',
      display: 'flex'
    }
  }, ___EmotionJSX(Label, {
    theme: theme
  }, userInput.prompt), ___EmotionJSX(CodeWithSyntaxHighlight, {
    colorizeCodeElement: colorizeCodeElement,
    language: userInput.language,
    theme: theme
  }, userInput.value));
};
export { UserInputDisplayer };